export default {
    props: {
        title: String,
        visible: {
            type: Boolean,
            default: false
        },
        data: Object
    },
    data(){
        return {
            popupVisible: false,
        }
    },
    watch: {
        visible(newValue){
            if(newValue != this.popupVisible){
                this.popupVisible = newValue;
            }
        },
        popupVisible(newValue){
            this.$emit('update:visible', newValue);
            if(newValue && this.init) this.init();
        }
    },
    methods: {
        close(){
            this.popupVisible = false;
        },
        emitSuccess(data){
            this.$emit('success', data || this.data);
        },
        emitChange(data){
            this.$emit('change', data || this.data);
        }
    }
}